// Dynamic role types - roles are fetched from the API
export type RoleId = number;
export type RoleName = string;

// Role summary interface matching the API response
export interface RoleSummary {
  id: number;
  name: string;
  description: string | null;
  isSystem: boolean;
  permissions: string[];
}

// Utility function to validate if a value is a valid role ID
export function isRoleId(value: unknown): value is RoleId {
  return typeof value === 'number' && value > 0;
}

// Utility function to resolve a role ID from various input types
export function resolveRoleId(value: unknown, fallback: RoleId | null = null): RoleId | null {
  // If already a valid role ID, return it
  if (isRoleId(value)) {
    return value;
  }

  // If string, try to parse as number
  if (typeof value === 'string') {
    const numeric = Number(value.trim());
    if (isRoleId(numeric)) {
      return numeric;
    }
  }

  return fallback;
}
